import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/home/frontru/aquaart-group/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/home/frontru/aquaart-group/src/components/ui/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/advantages/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/advantages/advantage-card/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/title/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/home/components/awards/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/brands/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/home/components/news/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/vacancy/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/success/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/success/success-card/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/home/components/slogan/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/image-text-block/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/home/components/vacancy/vacancy-card/index.tsx");
